const setUniversities = (state, payload) => {
  state.universities.push(...payload);
}

const setUniversity = (state, new_university) => {
  state.university = new_university;
}

export default {
  setUniversities,
  setUniversity,
}